import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { AuthService } from './services/auth.service';
import { SessionService } from './services/storage/session.service';

import { Session } from './models/session';
import { BasePaths, MemberPaths } from './constants/routes';
import { NavigationService } from './services/navigation.service';
import { AppGateService } from './services/app-gate.service';
// import { ColorVariable } from './constants/style-variables';
// import { StyleService } from './services/styles.service';

@Component({
    selector: 'mwp-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  public loginImage = '';
  public isLoggedIn: boolean;

  @ViewChild('appBody') appBody: ElementRef;
  public appBodyHaveVerticalScrollbar: boolean;
  private appBodyResizeObserver: ResizeObserver;
  private mutationObserver: MutationObserver;

  constructor(
    private authService: AuthService,
    private sessionService: SessionService,
    private router: Router,
    private navigationService: NavigationService,
    private el: ElementRef,
    // private styleService: StyleService
    public bannerService: AppGateService
  ) {
    this.sessionService.$Session.subscribe((session: Session) => {
      this.isLoggedIn = session.isLoggedIn;
    });

    // const primaryVarRGBA = `rgba(var(${ColorVariable.primaryRGB}))`;
    //this.loginImage = `linear-gradient(${primaryVarRGBA},${primaryVarRGBA})`;

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        // const primaryVarRGBA = `rgba(var(${ColorVariable.primaryRGB}),0.95)`;
        switch (event.url) {
          case '/':
          case BasePaths.Home:
          case BasePaths.Counselors:
          case BasePaths.Members:
          case BasePaths.Register:
          case BasePaths.VersionError:
          case BasePaths.AgentPasswordExpired:
          case BasePaths.AccountDeleted:
          case BasePaths.PrivacyPolicy:
            // this.baseImage(primaryVarRGBA);
            break;

          case MemberPaths.Dashboard:
          case MemberPaths.BenefitEnrollment:
            this.loginImage = '';
            break;

          default:
            // if (event.url.startsWith(BasePaths.ValidatePassword) || event.url.startsWith(BasePaths.ValidateAgentPassword) || event.url.startsWith(BasePaths.Passthrough)) {
            //   // this.baseImage(primaryVarRGBA);
            // } else if (event.url.startsWith(BasePaths.FirstResponders)) {
            if (event.url.startsWith(BasePaths.FirstResponders)) {
              if (!this.sessionService.session.isFirstResponder || this.sessionService.session.firstResponderComCode.toUpperCase() != event.url.split('/')[2].toUpperCase()) {
                this.sessionService.session.firstResponderComCode = event.url.split('/')[2].toUpperCase();
                this.sessionService.session.isFirstResponder = true;
                this.sessionService.setSession();
              }
              if (this.sessionService.session.firstResponderLoginImage == null) {
                const imageNumber2 = Math.floor(Math.random() * 5) + 1;
                // this.loginImage = `linear-gradient(${primaryVarRGBA},${primaryVarRGBA}), url(/assets/images/login-first-responders/background-${imageNumber2}.webp)`;
                this.sessionService.session.firstResponderLoginImage = this.loginImage;
                this.sessionService.setSession();
              } else {
                this.loginImage = this.sessionService.session.firstResponderLoginImage;
              }
            } else {
              this.loginImage = '';
            }
            break;
        }

        this.navigationService.buildNavMenu(event.url);
      }
    });
  }
  get shouldShowAppBanner(): boolean {
    return (
      this.bannerService.isMobile &&
      sessionStorage.getItem('hideAppBanner') !== 'true'
    );
  }
  private baseImage(primaryVarRGBA: string): void {
    // if (this.sessionService.session.loginImage == null) {
    //   const imageNumber = Math.floor(Math.random() * 6) + 1;
    //   this.loginImage = `linear-gradient(${primaryVarRGBA},${primaryVarRGBA}), url(/assets/images/login-banners/loginBanner${imageNumber}.webp)`;
    //   this.sessionService.session.loginImage = this.loginImage;
    //   this.sessionService.setSession();
    // } else {
    //   this.loginImage = this.sessionService.session.loginImage;
    // }


    // if (!this.sessionService.session || this.sessionService.session.isFirstLoad) {
    //   //const mediaQuery: MediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
    //   //this.styleService.setDarkModeIntial(mediaQuery.matches);
    //   this.styleService.setDarkModeIntial(false);
    // } else {
    //   this.styleService.setStyle();
    // }
  }

  ngOnInit(): void {
    this.authService.getOperatingMode().subscribe();
    this.appBodyResizeObserver = new ResizeObserver(() => this.checkScrollbar());
    this.appBodyResizeObserver.observe(this.el.nativeElement);
    this.mutationObserver = new MutationObserver(() => this.checkScrollbar());
    this.mutationObserver.observe(this.el.nativeElement, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }

  checkScrollbar(): void {
    const element = this.appBody.nativeElement;
    this.appBodyHaveVerticalScrollbar = element.scrollHeight > element.clientHeight;
  }
}
